import React from 'react';
import logo from 'assets/img/proximamente.png';

const DashboardMaster = () => {
    return (
        <div
            style={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                zIndex: 1,
                textAlign: 'center',
            }}
        >
            <img
                src={logo}
                alt="Próximamente"
                style={{
                    maxHeight: '70vh',
                    width: 'auto',
                }}
            />
        </div>
    );
};

export default DashboardMaster;